import { render } from "./LangSwitcher.vue?vue&type=template&id=7472cad2"
import script from "./LangSwitcher.vue?vue&type=script&lang=js"
export * from "./LangSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\PHPRad Projects\\ulcpv1\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__